
export default {
  confirm: {
    tips: {
      title: '※加盟店の申込をされるに当たって事前にご確認いただく事項',
      subtitle: '今回は、日本環球支付株式会社の加盟店のお申し込みをいただき、ありがとうございます。',
      content: '当社の加盟店になっていただくためには、貴社や代表者さま等の情報をシステム登録していただくほか、各種の証明資料等を添付していただくことが必要となります。',
      content1: 'お手数をおかけしますが、法令に基づく重要な手順となりますので、このシステムを順に操作し、正確で最新の情報をご提供いただきますようお願いします。',

    },

    specificterms: {
      title: '個別の確認事項',
      
       header: {
        checkbox: '下の全ての事項について理解し同意する。',
        description: ''
      },
      terms: {
        item1: '申込先は日本環球支付株式会社＊であること。',
        item11:'＊経済産業大臣登録キャッシュレス決済サービス提供事業者。',
        item2: '申込に必要な情報を日本環球支付株式会社に提供することに異議はないこと。',
        item3: {
          prefix: '加盟店として、法令及び日本環球支付株式会社の',
          globepay: '「GLOBEPAY加盟店規約」',
          middle: '及び',
          terms: '「決済端末及び関連機器に関する売買約款」',
          suffix: 'に従うこと'
        },
        item4: {
          main: '申込者（代表者及び会社）が次の法令違反に該当しないこと。',
          sub1: {
            text: '暴力団対策法に定める暴力団等反社会的勢力でない。',
            note: '※暴力団等反社会的勢力でないことについて、（三）の項の「表明・確約書」にも必要事項をご記入ください。'
          },
          sub2: '過去5年間に特定商取引法に基づく処分を受けたことがない。',
          sub3: '消費者契約法に違反したことを理由とする民事訴訟の敗訴判決を受けたことがない。'
        }
      },
      documentLinks: {
        globepay: '../../conditions.html',
        terms: '../../terms.html'
      }
      

    },
    contract: {
      title: '法令に基づく加盟店の責務について、',
      subtitle: '法令に基づく加盟店の責務について、以下の事項について理解し同意する。',

      expand: '詳細を表示する',
      collapse: '詳細を閉じる',
      terms: {
        title: '加盟店契約条項',
        subtitle: '日本非現金決済サービス加盟店としての義務',
        confirmText: '本人は上記のすべての条項を注意深く読み、完全に理解した上で、すべての規定を遵守することに同意します。',
        // 引言段落
        intro1: '日本でキャシュレス決済サービス事業の加盟店になっていただくことにより、加盟店には次のような法律や業界ルール上の義務等が課されることになります。',
        intro2: 'これは、加盟店が提供するサービスが、割賦販売法という法律に基づき社会生活に重大な影響を及ぼすものであり、このため、万一、加盟店が法令に違反する営業行為等を行った場合には、ご利用者等に多大の不利益やご迷惑を与えるためです。',
        intro3: '加盟店としてのこのような責務や違反行為に対する措置を十分にご理解いただき、今後の加盟店活動に当たっていただくようお願いします。',

        // 第一部分标题
        section1Title: '（1）法令等に基づく加盟店の責務',
        section1Intro: '法令等に基づき、加盟店には次のような責務が課されています。',

        // 责任表格
        responsibility: {
          tableHeader: {
            item: '項　目',
            content: '内　容'
          },
          items: [
            {
              no: '①コンプライアンスの遵守',
              content: '加盟店は法令や業界ルール等のコンプライアスンを遵守し、これに違反するような営業や宣伝活動等をしてはいけません。'
            },
            {
              no: '②反社会的勢力の排除',
              content: '暴力団等反社会的勢力は加盟店になれません。あとから反社会的勢力あると分かった場合は、加盟店契約が解除となります。'
            },
            {
              no: '③コンプライアンス違反をした場合の報告義務',
              content: '加盟店は、万一、コンプライアンス違反を行った場合には、速やかに弊社に報告をしなければいけません。故意に報告をしない場合は悪質行為として加盟店契約の解除の対象となります。'
            },
            {
              no: '④顧客情報管理の徹底',
              content: '加盟店は、顧客情報の管理をきちんとしなければなりません。万一、情報漏洩等があった場合には、速やかに弊社に報告しなければいけません。'
            },
            {
              no: '⑤届出事項の変更時の報告',
              content: '加盟店としての申請事項は法令に基づくものです。代表者や住所の変更、サブ加盟店の追加など申請時の届出内容の変更時にも、速やかに弊社に報告が必要です。'
            },
            {
              no: '⑥社内体制の整備と社員教育等',
              content: '①～⑤を守るために、加盟店としての社内体制を整備するほか、社員の教育・研修等も行っていただくことが必要となります'
            }
          ]
        },

        // 第二部分标题
        section2Title: '（2）加盟店の責務に違反した場合の措置',
        section2Intro: '上記（1）の法令に基づく加盟店の責務に違反した場合には、次のような措置が執られる場合があります。',

        // 处理措施
        measures: [
          '加盟店としての業務停止又は契約の解除',
          '違反行為について、社名の公表や業務改善命令、業務停止処分等',
          'その他、法令違反行為に対する罰則の適用'
        ],

        // 确认部分
        confirmText: '本人は上記のすべての条項を注意深く読み、完全に理解した上で、すべての規定を遵守することに同意します。'
      }
    },
    agreesection: {
      title: '以上の（一）、（二）及び（三）に記載した全ての事項を確認・同意した上で署名します。',
      content: 'なお、申込の後又は加盟店になった後に、事実に反する事項が見つかった場合には、本件申請が無効になる場合や加盟店の取消しがあることに同意します。',

    },
    confirm: {
      title: '事前確認',
      label1: '1.申込先：日本環球支付株式会社',
      label2: '2.申込情報及び決済サービスの利用状況について、申込先に提供することを同意する',
      label3: '3.GlobePay決済サービス加盟店規約25条1項に規定する反社会的勢力に自ら又は自らの役員が該当しない',
      label4: '4.風俗営業等の規制及び業務の適正化等に関する法律2条1項に規定する風俗営業を営む事業者に該当しない',
      label5: '5.特定商取引法・消費者契約法違反歴',
      tip: '※過去5年間に、特定商取引法による処分を受けたことがなく、かつ、消費者契約法に違反したことを理由とする民事訴訟の敗訴判決を受けたことがない',
    },
    transaction: {
      title: '取引の形態',
      label1: '下記の①～⑥に該当する取引形態ではない',
      label2: '①訪問販売',
      label3: '②特定継続的役務提供',
      label4: '③電話勧誘販売',
      label5: '④前払い式サービスの取引',
      label6: '⑤業務提供誘引販売',
      label7: '⑥連鎖販売',
      tip: '※該当がある場合は下記①～⑥の該当内容をチェック',
    },
    manage: {
      title: '運営形態ついて、加盟店の運営形態は次のとおり。',
      store: '個店',
      concession: 'フランチャイズ',
      no: '該当しない',
      status1: '個店（親店舗のみ）',
      status2: 'フランチャイズ',
      status3: '今回、親店舗以外の子店舗を同時期に開業する',
      status4: '今後、親店舗以外の子店舗を開業する予定がある',
    },
    statement: {
      title: '暴力等反社会的勢力ではないこと等に関する表明・確約書',
      tip: '日本環球支付株式会社が提供するクレジットカード番号等取扱契約締結事業の利用に関する契約を締結するに当たり、暴力団等反社会的勢力でないこと等について、以下のとおり表明・確約します。',
      label1: {
        title: '１.あなたまたはあなたの会社は反社会的勢力ではありませんか？',
        tip: '　私または私の会社は、現在又は将来にわたって、次の各号の反社会的勢力のいずれにも該当しないことを表明し確約いたします。',
        label1: '① 暴力団',
        label2: '② 暴力団員',
        label3: '③ 暴力団関係企業',
        label4: '④ 総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団等',
        label5: '⑤ その他前各号に準ずるもの',
        label1yes: '私または私の会社は反社会的勢力ではありません。',
        label1no: '私または私の会社は反社会的勢力です。',
      },
      label2: {
        title: '２.あなたまたはあなたの会社は反社会的勢力等と関係がありませんか？',
        tip: '　私または私の会社は、現在又は将来にわたって、前項の反社会的勢力と密接な交流関係にある者（以下、「反社会的勢力等」という。）と次の各号のいずれかに該当する関係も有しないことを表明し確約いたします。',
        label1: '① 反社会的勢力等によって、その経営を支配される関係',
        label2: '② 反社会的勢力等が、その経営に実質的に関与している関係',
        label3: '③ 反社会的勢力等に対して資金等を提供し、又は便宜を供与するなどの関係',
        label4: '④ その他反社会的勢力等との社会的に非難されるべき関係',
        label2yes: '私または私の会社は反社会的勢力等と一切関係ありません。',
        label2no: '私または私の会社は反社会的勢力等と関係があります。',

      },
      label3: {
        title: '３.あなたまたはあなたの会社は暴力的な要求行為等をしませんか？',
        tip: '　私または私の会社は，自ら又は第三者を利用して次の各号のいずれの行為も行わないことを表明し確約いたします。',
        label1: '① 暴力的な要求行為',
        label2: '② 法的な責任を超えた不当な要求行為',
        label3: '③ 取引に関して脅迫的な言動をし、又は暴力を用いる行為',
        label4: '④ 風説を流布し、偽計若しくは威力を用いて貴法人の信用を毀損し、又は貴法人の業務を妨害する行為',
        label5: '⑤ その他前各号に準ずる行為',
        label3yes: '私または私の会社は暴力的な要求行為等は一切しません。',
        label3no: '私または私の会社は暴力的な要求行為等をします。 ',
      },
      label4: {
        title: '４ あなた又はあなたの会社が反社会的勢力である場合に取引の停止や解約をされても異議などありませんか？',
        tip: '私又は私の会社は、これら各項のいずれかを満たさないと認められることが判明した場合及びこの表明、確約が虚偽の申告であることが判明した場合は、催告無しでこの取引が停止され又は解約されても一切異議を申し立てず、また賠償ないし補償を求めないとともに、これにより損害を生じた場合は、一切私又は私の会社の責任といたします。',
        label1: '以上',
        label4yes: '異議ありません。',
        label4no: '異議があります。',

      },
    },
    autograph: {
      legalrepposition: '代表者役職',
      legalname: '氏名',
      autograph: '上記事項を確認したうえで署名しました。',
      btn: '署名する',
      clear: 'クリア',
      ok: '確認',
      errorMsg: '枠内にサインをお願いします',
    },
    file: '「日本環球支付株式会社GLOBEPAY加盟店規約」',
    file2: 'を確認し、同意しました',
    terms: '決済端末及び関連機器に関する売買約款を確認し、同意しました',
    liabilityterms: '（一）法令に基づく加盟店の責務について、以下の事項について理解し同意する。',
  }
}
